import script from "./ModalAiSetupAvatarSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAiSetupAvatarSection.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAiSetupAvatarSection.vue?vue&type=style&index=0&id=d64e2094&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d64e2094"]])

export default __exports__